module.exports = __webpack_public_path__ + "img/fig_dofa_2.ae380d0c.svg";